import { Pipe, PipeTransform } from '@angular/core'
import VERSION_TYPE from '../../../constants/versionType.constant'

@Pipe({ name: 'displayVersionTypeTitleText' })
export class DisplayVersionTypeTitleTextPipe implements PipeTransform {
    transform(versionType, appendixNumber, appendixNumberMax?): string {
        switch (versionType) {
            case VERSION_TYPE.appendix:
                const appendixNum = appendixNumber
                    ? appendixNumber
                    : appendixNumberMax + 1
                if (appendixNum) {
                    return 'po dodatku č. ' + appendixNum
                } else {
                    return ''
                }
            case VERSION_TYPE.digitization:
                return 'po digitalizaci'
            case VERSION_TYPE.inflationAdjustment:
                return 'po ruční úpravě o inflaci'
            case VERSION_TYPE.valorizationAdjustment:
                return 'po ruční valorizaci'
            case VERSION_TYPE.reprice:
                return 'po přecenění'
            case VERSION_TYPE.automaticReprice:
                return 'po automatickém přecenění'
            case VERSION_TYPE.automaticRepriceAndInflationIncrease:
                return 'po automatickém přecenění a navýšení o inflaci'
            case VERSION_TYPE.automaticInflationIncrease:
                return 'po automatickém navýšení o inflaci'
            case VERSION_TYPE.automaticValorization:
                return 'po automatické valorizaci'
            case VERSION_TYPE.other:
                return 'po jiné úpravě'
            default:
                return ''
        }
    }
}